if (!customElements.get('product-coming-soon-slider')) {
  customElements.define(
    'product-coming-soon-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pcs-track]');
        this.cards = Array.from(
          this.querySelectorAll('.product-coming-soon__card')
        );
        this.dots = Array.from(
          this.querySelectorAll('[data-pcs-dot]')
        );

        if (!this.track || this.cards.length < 2) return;

        this.controller?.abort();
        this.controller = new AbortController();

        const { signal } = this.controller;

        this.mobile = window.matchMedia('(max-width: 749px)');

        this.dots.forEach((dot, index) => {
          dot.addEventListener(
            'click',
            () => {
              if (!this.mobile.matches) return;

              const trackRect = this.track.getBoundingClientRect();
              const cardRect = this.cards[index].getBoundingClientRect();
              const isRTL =
                getComputedStyle(this.track).direction === 'rtl';

              const distance = isRTL
                ? cardRect.right - trackRect.right
                : cardRect.left - trackRect.left;

              this.track.scrollBy({
                left: distance,
                behavior: window.matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches
                  ? 'auto'
                  : 'smooth'
              });
            },
            { signal }
          );
        });

        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.updateDots());
          },
          { passive: true, signal }
        );

        this.mobile.addEventListener(
          'change',
          () => {
            this.track.scrollLeft = 0;
            this.updateDots();
          },
          { signal }
        );

        this.resizeObserver = new ResizeObserver(() => this.updateDots());
        this.resizeObserver.observe(this.track);

        this.updateDots();
      }

      updateDots() {
        const trackRect = this.track.getBoundingClientRect();
        const isRTL = getComputedStyle(this.track).direction === 'rtl';

        let activeIndex = 0;
        let nearestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const distance = Math.abs(
            isRTL
              ? cardRect.right - trackRect.right
              : cardRect.left - trackRect.left
          );

          if (distance < nearestDistance) {
            nearestDistance = distance;
            activeIndex = index;
          }
        });

        this.dots.forEach((dot, index) => {
          const active = index === activeIndex;

          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    }
  );
}